import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoDirective } from '@jsverse/transloco';
import { Language } from '../language-storage';
import { TranslationService } from '../translation.service';

@Component({
  selector: 'ld-language-toggle',
  imports: [MatIconModule, MatMenuModule, TranslocoDirective],
  templateUrl: './language-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageToggleComponent {
  protected readonly translationService = inject(TranslationService);

  protected selectLanguage(language: Language): void {
    this.translationService.setLanguage(language);
  }
}
